import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import * as application from '../actions/application-detail.actions';
import { AppsRestClient } from '../services/apps-rest-client.service';
import { ApplicationsState } from '../applications.state';
import { Store } from '@ngrx/store';
import {
    selectApplicationDetails, selectBackupApplicationDetails,
    selectExpandedApplicationList
} from '../application.selector';
import { shouldBeLoaded } from '../services/applications.helper';
import { ApplicationMap } from '../model/modified-applications.model';
import { RevertPermissionsRequestAction } from '../actions/application-detail.actions';
import { ApplicationDetail } from '../model/application/application-detail.model';
import { addIdsToAccountGroups } from '../../shared/helper/account-group-id-adder.helper';

import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/withLatestFrom';

@Injectable()
export class ApplicationDetailEffects {

    /**
     * Side effect to trigger application detail fetch as a result of expanding application detail.
     */
    @Effect() expandApplicationDetail$ = this.actions$
        .ofType(application.TOGGLE_DETAIL)
        .withLatestFrom(this.store.select(selectExpandedApplicationList))    // expanded application list
        .withLatestFrom(this.store.select(selectApplicationDetails)) // list with application details fetched from server
        .mergeMap(([[action, expanded], details]) => {
            let appId = (<application.ToggleDetailAction>action).payload.appId;

            if (shouldBeLoaded(appId, expanded, details)) {
                return Observable.of(new application.LoadRequestAction(appId));
            } else {
                // https://stackoverflow.com/questions/39761826/how-to-dispatch-an-empty-action
                return Observable.empty();
            }
        });

    /**
     * Side effect to load application detail as a result of expanding application detail.
     */
    @Effect() loadDetail$ = this.actions$
        .ofType(application.LOAD_REQUEST)
        .switchMap((action: application.LoadRequestAction) => this.client.loadApplicationDetail(action.payload)
            .map((payload: ApplicationDetail) => {
                addIdsToAccountGroups(payload.accountsGroups);
                return (new application.LoadSuccessAction(payload));
            })
            // If request fails, dispatch failed action
            .catch(error => Observable.of(new application.LoadErrorAction(error)))
        );

    @Effect() revertChanges$ = this.actions$
        .ofType(application.REVERT_PERMISSIONS_REQUEST)
        .withLatestFrom(this.store.select(selectBackupApplicationDetails))
        .map(([action, backupApplications]: ([RevertPermissionsRequestAction, ApplicationMap])) =>
            new application.RevertPermissionsFinishAction(backupApplications[action.payload]));

    constructor(private store: Store<ApplicationsState>,
                private client: AppsRestClient,
                private actions$: Actions) {
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/effects/application-detail.effects.ts